import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { auth } from '@atlaskit/outbound-auth-flow-client';
import { sanitizeUrl } from '../UIKit1/markup';
export var ATLASSIAN_AUTH_SERVICE_KEY = 'atlassian-token-service-key';
export var safeAuth = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startUrl, windowFeatures) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", auth(sanitizeUrl(startUrl), windowFeatures));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function safeAuth(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var isExternalAuth = function isExternalAuth(startUrl) {
  var url = new URL(startUrl || '', window.location.href);
  var serviceKey = url.searchParams.get('serviceKey');
  return serviceKey !== ATLASSIAN_AUTH_SERVICE_KEY;
};